// Words for grown-up helpers and new recovery codes (#197), from the approved
// mockup. Style guide: cozy, short, kid-readable.

export const ACCOUNT_TEXT = {
  oneMoment: 'One moment…',
  back: 'Back',
  notNow: 'Not now',
  done: 'Done',

  helpingHeading: 'Players I help',
  stopHelping: 'Stop helping',
  keepHelping: 'Keep helping',
  helpersHeading: 'My helpers',
  helperBadge: 'Helper',
  waitingBadge: 'Waiting',
  helperCan: 'Can see your name and reset your password.',
  noHelper: 'No helper yet.',
  addHelper: 'Add a helper',
  remove: 'Remove',

  codeHeading: 'Recovery code',
  codeHint: 'Lost it? Make a new one. Your old code stops working.',
  newCode: 'Make a new recovery code',
  newCodeTitle: 'Make a new recovery code?',
  newCodeSubtitle: "Type your password to make sure it's you.",
  yourPassword: 'Your password',
  oldCodeStops: 'Your old code stops working right away.',
  makeCode: 'Make new code',
  newCodeReady: 'Your new code is ready!',

  asksHeading: 'Helper asks',
  askMeta: "You'll be able to see their name and reset their password.",
  sayYes: 'Say yes',
  noThanks: 'No thanks',

  addTitle: 'Add a helper',
  addSubtitle: "Pick a grown-up you play with. They'll be asked first.",
  nobody: 'Helpers are grown-ups. Ask a grown-up in your patch to join!',

  theirName: 'Their name is:',
  anyCase: 'Big or small letters both work.',
  forgotTheirs: 'Forgot their password?',
  resetPassword: 'Reset password',
  reset: 'Reset',
  resetReady: 'New password ready',
  password: 'Password',
  recoveryCode: 'Recovery code',
  resetHowTo:
    'They log in with the password, then pick a new one with "Forgot your password?" and the code.',
} as const;
